import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeModuleComponent } from './modules/home-module/home-module.component';
import { AccountComponent } from './modules/account/account.component';

const routes: Routes = [
  {
    path: 'account',
    component: AccountComponent,
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'home',
    component: HomeModuleComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/home-module/home-module.module').then(
        (m) => m.HomeModuleModule
      ),
  },
  {
    path: 'solution_app/o/authorize',
    canActivate: [AuthGuard],
    component: AccountComponent,
  },
  // Default route - will be handled by app component to redirect based on user role
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: HomeModuleComponent,
  },
  // 404 page - must be last
  { path: '**', component: NotFoundPageComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
